export const VIEW_SUBJECT = "VIEW_SUBJECT"
export const VIEW_SUBJECT_SUCCESS = "VIEW_SUBJECT_SUCCESS"
export const VIEW_SUBJECT_FAILED = "VIEW_SUBJECT_FAILED"